/**
 * Channel Adapter
 * Transforms channel data between API and application layer
 */

import { BaseAdapter } from './base.adapter';
import type {
  Channel,
  UpdateChannelDto,
  ChannelResponseDto,
} from '@/types';

export class ChannelAdapter extends BaseAdapter {
  /**
   * Adapts channel from API response
   */
  static fromApi(dto: ChannelResponseDto): Channel {
    return {
      id: dto.id,
      name: dto.name,
      accountId: dto.accountId,
      isDefault: dto.isDefault,
      behaviour: dto.behaviour,
      tone: dto.tone,
      answerLength: dto.answerLength,
      tags: dto.tags || [],
      inboxId: dto.inboxId,
      metadata: dto.metadata,
      createdAt: dto.createdAt,
      updatedAt: dto.updatedAt
    };
  }

  /**
   * Adapts channels array from API response
   */
  static fromApiList(dtos: ChannelResponseDto[]): Channel[] {
    return dtos.map((dto) => this.fromApi(dto));
  }

  /**
   * Adapts update channel request
   */
  static toUpdateRequest(data: UpdateChannelDto): UpdateChannelDto {
    const payload: UpdateChannelDto = {};

    if (data.name !== undefined) payload.name = data.name.trim();
    if (data.behaviour !== undefined) payload.behaviour = data.behaviour.trim();
    if (data.tone !== undefined) payload.tone = data.tone;
    if (data.answerLength !== undefined) payload.answerLength = data.answerLength;
    if (data.tags !== undefined) payload.tags = data.tags;
    if (data.metadata !== undefined) payload.metadata = data.metadata;

    return this.sanitizePayload(payload);
  }
}

